// Carousel dot indicators for product cards on collection pages.
// Adds pagination dots whenever a product card has 2+ slides; highlights the active one.
(function () {
  function init() {
    var els = document.querySelectorAll('.product-card slideshow-component');
    els.forEach(function (ss) {
      if (ss.dataset.edpDots) return;
      var slides = ss.querySelectorAll('slideshow-slide');
      if (slides.length < 2) return;
      ss.dataset.edpDots = '1';

      var dots = document.createElement('div');
      dots.className = 'edp-dots';
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('span');
        d.className = 'edp-dots__dot' + (i === 0 ? ' edp-dots__dot--active' : '');
        dots.appendChild(d);
      }

      var gallery = ss.closest('.card-gallery') || ss.parentElement;
      if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
      gallery.appendChild(dots);

      var dotEls = dots.querySelectorAll('.edp-dots__dot');
      var rootEl = ss.querySelector('slideshow-slides') || ss;

      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio > 0.5) {
              var idx = Array.prototype.indexOf.call(slides, e.target);
              if (idx > -1) {
                dotEls.forEach(function (d, i) {
                  d.classList.toggle('edp-dots__dot--active', i === idx);
                });
              }
            }
          });
        }, { root: rootEl, threshold: [0.5, 0.9] });
        slides.forEach(function (s) { io.observe(s); });
      } catch (err) { /* IO not supported, fall back to no live update */ }
    });
  }

  // Run on first ready, then poll for late-hydrating web components
  var attempts = 0;
  function poll() {
    attempts++;
    init();
    if (attempts < 12) setTimeout(poll, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();
